module.exports = __webpack_public_path__ + "static/media/dwarf.6ecc0789.gif";